export default {
  googleRecaptchaSiteKey: "6LfDCA8gAAAAAFyqEdlKrumhfJoGt23HNTrr8dGH",
};
